import { apiClient } from "./apiClient";
import { getAuthContext } from "./authContext";

type JurionCreateChatResponse = {
  data?: {
    id?: string;
    title?: string;
  };
};

type JurionMessagesResponse = {
  data?: {
    messages?: Array<{
      id: string;
      role: "user" | "assistant";
      content: string;
      createdAt?: string;
    }>;
  };
};

type JurionMessageReply = {
  content?: string;
};

export const jurionChatService = {
  async createResearchChat(title?: string) {
    const auth = getAuthContext();
    const response = await apiClient.post<JurionCreateChatResponse>(
      `/${auth.tenantId}/chatbot/chat`,
      {
        type: "research",
        // Only send a title if the caller provided one. The previous default
        // ("Jurion Word Session") was being echoed back by the LLM as a header.
        ...(title ? { title } : {}),
      }
    );
    const chatId = response.data?.data?.id;
    if (!chatId) {
      throw new Error("Unable to create Jurion chat.");
    }
    return chatId;
  },

  async sendMessage(
    chatId: string,
    content: string,
    options: { tids?: Array<string | number>; metadata?: Record<string, unknown> } = {}
  ) {
    const auth = getAuthContext();
    const response = await apiClient.post<{ data?: JurionMessageReply }>(
      `/${auth.tenantId}/chatbot/chat/${chatId}/message`,
      {
        content,
        tids: options.tids,
        metadata: options.metadata,
      }
    );
    return response.data?.data?.content || "";
  },

  async getMessages(chatId: string) {
    const auth = getAuthContext();
    const response = await apiClient.get<JurionMessagesResponse>(
      `/${auth.tenantId}/chatbot/chat/${chatId}`
    );
    return response.data?.data?.messages || [];
  },
};
